module.exports = "blogauthors"